import React from 'react';
import { useAuth } from '@/lib/auth';
import { Navigate } from 'react-router-dom';

export function RequireUser({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="p-10 text-center text-muted-foreground">Loading...</div>;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

export function RequireReseller({ children }) {
    const { reseller, loading } = useAuth();
    if (loading) return <div className="p-10 text-center text-muted-foreground">Loading...</div>;
    if (!reseller) return <Navigate to="/reseller/login" replace />;
    return children;
}

export function RequireAdmin({ children }) {
    const { admin, loading } = useAuth();
    if (loading) return <div className="p-10 text-center text-muted-foreground">Loading...</div>;
    if (!admin) return <Navigate to="/admin/login" replace />;
    return children;
}
